export default () => {
  // District picker
  $("select[name=distrikt]").change((e) => {
    const value = $(e.target).val(),
      select = $("select[name=kommun]");

    var data = {
      action: "get_municipalities",
      district: value,
    };
    // eslint-disable-next-line no-undef
    $.post(localize.ajaxurl, data, (response) => {
      response = JSON.parse(response);

      select.html(`
					<option value="0">
						Alla
					</option>
				`);

      Object.keys(response).forEach((key) => {
        const value = response[key];

        select.append(`
						<option value="${value}">
							${value}
						</option>
					`);
      });
    });
  });

  // Municipalities picker
  $("select[name=kommun]").change((e) => {
    const value = $(e.target).val();

    var data = {
      action: "get_districts",
      municipality: value,
    };

    //eslint-disable-next-line no-undef
    $.post(localize.ajaxurl, data, (response) => {
      response = JSON.parse(response);

      if (response.length != 0) {
        Object.keys(response).forEach((key) => {
          $('select[name="distrikt"] option').each((index) => {
            const option = $(
              `select[name="distrikt"] option:nth-of-type(${index + 1})`
            );

            if (key == option.val()) {
              option.attr("selected", "selected");
            }
          });
        });
      } else {
        $('select[name="distrikt"] option').each((index) => {
          const option = $(
            `select[name="distrikt"] option:nth-of-type(${index + 1})`
          );

          option.removeAttr("selected");
        });
      }
    });
  });

  /**
   * Redirect instagram login
   * (Because we can't set 500 redirect urls in app settings)
   */
  if (
    window.location.hash &&
    window.location.hash.split("=")[0] == "#access_token"
  ) {
    let blog_id = window.location.href.split("?blog_id=")[1];
    let access_key = window.location.hash.split("=")[1];

    blog_id = blog_id.split("#")[0];

    const data = {
      action: "login_instagram",
      access_key,
      blog_id,
    };

    // eslint-disable-next-line no-undef
    $.post(localize.ajaxurl, data, (response) => {
      window.location.href = `${response}wp-admin/admin.php?page=acf-options-allmant#access_token=${access_key}`;
    });
  }

  /**
   * Get Instagram posts
   */
  // const igFeeds = $('.c-sectionSocialFeed__instagram');

  // if (igFeeds) {
  // 	// eslint-disable-next-line no-undef
  // 	$.post(localize.ajaxurl, {
  // 		action: 'get_ig_key',
  // 	}, response => {
  // 		if (response) {
  // 			$.get(`https://api.instagram.com/v1/users/self/media/recent?access_token=${response}`, response => {
  // 				// eslint-disable-next-line no-undef
  // 				$.post(localize.ajaxurl, {
  // 					action: 'get_instagram_posts',
  // 					posts: response,
  // 				}, response => {
  // 					$('.c-sectionSocialFeed--instagram').html(response);
  // 				});
  // 			});
  // 		}
  // 	});
  // }

  /**
   * Get Facebook posts
   */
  // const fbFeeds = $('.c-sectionSocialFeed--facebook');

  // if (fbFeeds) {
  // 	//eslint-disable-next-line no-undef
  // 	$.post(localize.ajaxurl, {
  // 		action: 'get_fb_posts',
  // 	}, response => {
  // 		$('.c-sectionSocialFeed--facebook').html(response);
  // 	})
  // }
};
